import axios from 'axios'

export interface PlotPlanOption {
  plotPlanId: string
  plotPlanVersionId: string
  name: string
  backgroundPath?: string | null
}

export interface PlotPlanGps {
  plotPlanId: string
  name: string
  latitude?: number | null
  longtitude?: number | null
}

export interface OrgDepartment {
  departmentId: string
  name: string
  code?: string | null
  siteId?: string | null
  locationId?: string | null
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, '')}${path}`
  }
  return path
}

export async function getPlotPlans(locationId: string): Promise<PlotPlanOption[]> {
  if (!locationId) {
    return []
  }

  try {
    const response = await axios.get<PlotPlanOption[]>(buildUrl('/api/v1/work-areas/plot-plans'), {
      params: { locationId },
    })
    return response.data ?? []
  } catch (error) {
    console.warn('Failed to load plot plans', error)
    return []
  }
}

export async function getDefaultGps(locationId: string): Promise<PlotPlanGps | null> {
  if (!locationId) {
    return null
  }

  try {
    const response = await axios.get<PlotPlanGps>(buildUrl('/api/v1/work-areas/default-gps'), {
      params: { locationId },
    })
    return response.data ?? null
  } catch (error) {
    console.warn('Failed to load default GPS', error)
    return null
  }
}

export async function getOrgDepartments(params: {
  tenantId: string
  search?: string | null
  pageNumber?: number
  pageSize?: number
}): Promise<OrgDepartment[]> {
  if (!params.tenantId) {
    return []
  }

  try {
    const response = await axios.get<{ items?: OrgDepartment[] } | OrgDepartment[]>(
      buildUrl('/api/v1/org-departments'),
      {
        params: {
          tenantId: params.tenantId,
          search: params.search || undefined,
          pageNumber: params.pageNumber ?? 1,
          pageSize: params.pageSize ?? 100,
        },
      },
    )

    if (Array.isArray(response.data)) {
      return response.data
    }
    return response.data?.items ?? []
  } catch (error) {
    console.warn('Failed to load org departments', error)
    return []
  }
}
